import type {
  MultidietCateringsTierType,
  MultidietCateringsType,
} from "@/features/multidiet/types/multidiet-caterings.type";
import { GET } from "@/lib/methods";

export const getMultidietCateringsByTier = ({
  params,
  tier,
}: {
  params?: RequestInit;
  tier: MultidietCateringsTierType;
}): Promise<MultidietCateringsType[]> => {
  return GET<MultidietCateringsType[]>({
    url: `${process.env.NEXT_PUBLIC_CATALOG_URL}/caterings-tier/${tier}`,
    params: {
      next: {
        tags: [`multidiet-caterings-${tier}`],
        revalidate: 60,
      },
      headers: {
        "Content-Type": "application/json",
      },
      ...params,
    },
  });
};
